import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    pendingHeader: {
        id: '_.pending_view.header',
        defaultMessage: 'We won’t be a minute!'
    },
    pendingDescription: {
        id: '_.pending_view.description',
        defaultMessage: 'Thank you for completing your application.'
    }
});
